import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { SharedConsent } from '../../../models/consent.model';

export interface DownloadConfirmDialogData {
  existingConsent: SharedConsent;
}

export type DownloadConfirmResult = 'same' | 'latest';

@Component({
  selector: 'app-download-confirm-dialog',
  templateUrl: './download-confirm-dialog.component.html',
  styleUrls: ['./download-confirm-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule
  ]
})
export class DownloadConfirmDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<DownloadConfirmDialogComponent, DownloadConfirmResult>,
    @Inject(MAT_DIALOG_DATA) public data: DownloadConfirmDialogData
  ) {}

  get createdAt(): Date | undefined {
    return this.data.existingConsent.createdAt;
  }

  onDownloadSame(): void {
    this.dialogRef.close('same');
  }

  onDownloadLatest(): void {
    this.dialogRef.close('latest');
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
